export const gMap = {
    API_KEY: "AIzaSyBQUmk7hdajZEAYllxKhVPnUx5pXuK-j_Y"
}